import React from 'react';
import PropTypes from 'prop-types';

function ErrorMessage({ title, message, icon }) {
  return (
    <div
      style={{ minHeight: '500px' }}
      className="d-flex flex-column align-items-center justify-content-center text-center"
      role="alert"
    >
      {icon && (
        <div className="p-4" aria-hidden="true">
          {icon}
        </div>
      )}
      <h3 className={'text-danger'}>{title}</h3>
      <div>{message}</div>
    </div>
  );
}

ErrorMessage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  icon: PropTypes.object
};

ErrorMessage.defaultProps = {
  title: '',
  message: '',
  icon: null
};

export default ErrorMessage;
